import { render, staticRenderFns } from "./ModelPage.vue?vue&type=template&id=21bbe57a&scoped=true"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"
import style0 from "./ModelPage.vue?vue&type=style&index=0&id=21bbe57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbe57a",
  null
  
)

export default component.exports